module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/top_dot-ebe1b5bdad80c8ec1f99b3b9c5b27c97.png";